var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multi-selector',{attrs:{"filterable":false,"options":_vm.selfStatusList,"remote":_vm.selfStatusSearch},model:{value:(_vm.self),callback:function ($$v) {_vm.self=$$v},expression:"self"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42ed98d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bussiness-select/SelfStatusSelector.vue
// module id = null
// module chunks = 